import { Box, Typography, styled, Button } from "@mui/material";
import { colors } from "../../../theme/colors";

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
});

export const ModalTitle = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  color: colors.text.primary,
  textAlign: "center",
  marginBottom: "12px",
});

export const ModalText = styled(Typography)({
  color: "#6B7A94",
  textAlign: "center",
  fontFamily: "Sora, sans-serif",
  fontSize: "18px",
  fontWeight: 600,
  lineHeight: "32px",
});

export const ButtonsContainer = styled(Box)({
  display: "flex",
  gap: "24px",
  justifyContent: "center",
  marginTop: "60px",
});

export const DiscardButton = styled(Button)({
  backgroundColor: "#EF5350",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#D32F2F",
  },
});


